import { TranslatePipe } from '../../filters/translate.pipe';
import { ListServicesComponent } from '../../components/list-services/list-services.component';
import { ListAppointmentsComponent } from '../../components/list-appointments/list-appointments.component';
import { CardSymptomsComponent } from '../../components/card-symptoms/card-symptoms.component';
import { ListCoachingTopicsComponent } from '../../components/list-coaching-topics/list-coaching-topics.component';
import { ListServicesInstantComponent } from '../../components/list-services-instant/list-services-instant.component';
import { Component, OnInit, OnDestroy, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import UrlUtil from '../../utils/url-util.service';
import Config from '../../utils/config.service';
import ServiceRestServices from '../../services/service-rest.service';
import FetchingService from '../../services/fetching.service';
import StatusService from '../../services/status.service';
import RestService from '../../services/core-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import RoutingService from '../../services/routing.service';
import moment from 'moment';
import { PanelDirective } from '../../directives/panel.directive';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { Subscription, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
	standalone: true,
	selector: 'home',
	templateUrl: './home.component.html',
	imports: [
		CommonModule, MatSelectModule, PanelDirective, TranslatePipe, 
		ListServicesComponent, ListAppointmentsComponent, CardSymptomsComponent, 
		ListCoachingTopicsComponent, ListServicesInstantComponent, FormsModule
	]
})
export default class HomeView implements OnInit, OnDestroy {
	private session: Session = inject(Session);
	private urlUtil: UrlUtil = inject(UrlUtil);
	private config: Config = inject(Config);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private fetchingService: FetchingService = inject(FetchingService);
	private statusService: StatusService = inject(StatusService);
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	searchSubject: Subject<string> = new Subject<string>();
	vm: any = undefined;
	watcher: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	conditionPanelWidth: number | null = null;
	therapyPanelWidth: number | null = null;

	@ViewChild('conditionSelect')
	set conditionSelect(select: MatSelect | undefined) {
		this.updatePanelWidth('conditionPanelWidth', select);
	}

	@ViewChild('therapySelect')
	set therapySelect(select: MatSelect | undefined) {
		this.updatePanelWidth('therapyPanelWidth', select);
	}
	
	constructor() {
		this.vm = this;
		this.vm.search = {};
		
		this.searchSubject.pipe(
			debounceTime(500)
		).subscribe(searchTerm => {
			this.triggerSearch(false);
		});
	}
	
	ngOnInit() {
		this.vm.initialized = false;
		this.routingService.validateAccess('home').then(() => {
			this.onResolve();
		});
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	onSearchChange(searchTerm: string) {
		this.searchSubject.next(searchTerm);
	}
	
	onResolve() {
		this.vm.user = this.session.getSession().user;
		this.vm.partnersSupported = this.vm.user.parentBusinessUser
			&& this.vm.user.parentBusinessUser.service
			&& this.vm.user.parentBusinessUser.service.partnersEnabled === true;
		this.vm.hideServiceProvidersForCoaching = false;
		if (this.vm.user && this.vm.user.previsitUser) {
			if (this.vm.user.businessUserType === 'SERVICE_PROVIDER'
					&& this.vm.user.service
					&& this.vm.user.service.preVisitEnabled) {
				this.angularRoutingHelperService.setPath('/pre-visit/record-ticket-for-person');
			} else {
				this.angularRoutingHelperService.setPath('/pre-visit');
			}
			return;
		} else if (this.vm.user && this.vm.user.businessUserType) {
			this.angularRoutingHelperService.home(this.vm.user);
			return;
		}
		this.vm.availableTags = [];
		this.vm.availableTherapies = [];
		this.vm.typeOfAppointments = ['FACE_TO_FACE_SESSION_ONLY', 'VIDEO_SESSION_ONLY'];

		this.vm.avTestUrl = this.urlUtil.createAvTestUrl();

		this.vm.params = this.angularRoutingHelperService.getQueryParams();
		this.vm.selectedTab = this.vm.params['category'] === 'PSYCHOLOGY' ? 2 
		    : this.vm.params['category'] === 'COACH_SUPERVISOR' ? 1 
		    : this.vm.params['category'] === 'EMPLOYER_PAYS' ? 3 
		    : 0;
		this.vm.hideServiceProvidersForCoaching = (this.vm.params['showCoaching'] && !this.vm.params['coachingTopics']);
		this.vm.isInCoachingFlow = this.vm.params['showCoaching'];
		this.vm.alternativeServicesTitle = (this.vm.user.origin == 'siffi.com');
		this.vm.showCoachingTopics = (this.vm.user.origin == 'siffi.com' || this.vm.params['showCoaching']);
		this.vm.coachingScrollPerformed = false;
		this.vm.isWeightLossFlow = this.vm.params['weightLossServiceSupport'] === 'true';
		this.getAppointments();

		this.vm.isSearchable = this.vm.user.origin == 'siffi.com'
			&& (this.angularRoutingHelperService.getCurrentPath() === '/' || this.angularRoutingHelperService.getCurrentPath() === '')
			&& !this.vm.user.businessUser;
		if (this.vm.isSearchable) {
			this.initializeSearch();
		}
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, this.config.getBroadcastConfig().Services.BOOKING_CANCELLED,
				(event, id) => {
					this.getAppointments();
				})
		);
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, this.config.getBroadcastConfig().Services.SEARCH,
				(e, data) => {
					console.log('Broadcast event: ' + e.name + ' in views/home, triggered from: ' + data.origin);
					this.vm.params = this.angularRoutingHelperService.getQueryParams();
					this.vm.showCoachingTopics = (this.vm.user.origin == 'siffi.com' || this.vm.params['showCoaching']);
					this.vm.isInCoachingFlow = this.vm.params['showCoaching'];
					this.vm.hideServiceProvidersForCoaching = (this.vm.params['showCoaching'] && !this.vm.params['coachingTopics']);
					if (this.vm.showCoachingTopics) {
						this.getCoachingTopics();
					}
				})
		);
		this.vm.servicesTitle = this.vm.isWeightLossFlow ? this.angularHelperService.trustAsHtml(this.angularFilterHelperService.translate('Services.Category.WEIGHT_LOSS_SPECIALISTS')) : this.angularHelperService.trustAsHtml(this.angularFilterHelperService.translate('Services.Category.ALL'));
		
		var currentStatuses = [];
		this.watcher = this.angularHelperService.createInterval(() => {
			var newStatuses = this.statusService.getStatuses();
			if (!this.angularHelperService.isEqual(newStatuses, currentStatuses)) {
				console.log("Statuses updated", currentStatuses, newStatuses);
				currentStatuses = newStatuses;
				this.handleStatusUpdates(newStatuses);
			}
		}, 300);
		
		this.vm.triggerSearch = this.triggerSearch;
		this.vm.getLanguagesText = this.getLanguagesText;
		this.vm.getLocationText = this.getLocationText;
		this.vm.getConditionsText = this.getConditionsText;
		this.vm.getTherapiesText = this.getTherapiesText;
		this.vm.toggleDrawer = this.toggleDrawer;
		this.vm.handleTabClick = this.handleTabClick;
		this.vm.conditionPanelWidth = this.conditionPanelWidth;
		this.vm.therapyPanelWidth = this.therapyPanelWidth;
		
		this.getTags();
		this.getTherapies();
		if (this.vm.showCoachingTopics) {
			this.getCoachingTopics();
		}
		this.vm.tabs = [{
			id: '0',
			label: this.angularFilterHelperService.translate('Services.Other.Tab_All'),
			name: 'ALL'
		}];
		this.vm.tabs.push({
			id: '1',
			label: this.angularFilterHelperService.translate('Services.Other.Tab_Coaches'),
			name: 'COACH_SUPERVISOR'
		});
		this.vm.tabs.push({
			id: '2',
			label: this.angularFilterHelperService.translate('Services.Other.Tab_Therapists'),
			name: 'PSYCHOLOGY'
		});
		this.vm.tabs.push({
			id: '3',
			label: this.angularFilterHelperService.translate('Services.Other.Tab_Employer_Pays'),
			name: 'EMPLOYER_PAYS'
		});
		if (this.vm.partnersSupported) {
			this.vm.tabs.push({
				id: '4',
				label: this.angularFilterHelperService.translate('Partners.Title'),
				name: 'PARTNERS',
				route: '/partners'
			});
		}
		this.vm.initialized = true;
	}
	
	handleTabClick(index) {
		if (this.vm.tabs[index].route) {
			this.angularRoutingHelperService.setPath(this.vm.tabs[index].route);
			return;
		}
		this.vm.selectedTab = index;
		for (var i = 0; i < this.vm.tabs.length; i++) {
			if (this.vm.tabs[i].id == this.vm.selectedTab) {
				this.vm.search.category = this.vm.tabs[i].name;
				delete this.vm.search.therapies;
			}
		}
		this.vm.triggerSearch();
	}
	
	getAppointments() {
		this.serviceRestServices.activeBookings({ forBusiness: false }, (appointments) => {
			appointments = appointments || [];
			appointments.forEach((item) => {
				item.date = moment(item.scheduledStart).format('D MMMM YYYY');
				item.startTime = moment(item.scheduledStart).format('k:mm');
				item.endTime = moment(item.scheduledEnd).format('k:mm');
			});
			this.vm.appointments = appointments;
			
			if (appointments) {
				this.handleStatusUpdates(this.statusService.getStatuses());
				var users: any = appointments.map((appointment) => { return appointment.service.user.id; })
					.filter((v, i, self) => { return self.indexOf(v) === i; })
					.map((id) => { return { id: id }; });
				this.statusService.addUsers(users);
			}
		});
	}
	
	getTags() {
		this.restService.getServiceProviderTags({ language: this.vm.user.deviceLanguage })
			.then((tags) => {
				this.vm.availableTags = tags;
			})
			.catch((err) => {
				console.error(err);
			});
	}
	
	getTherapies() {
		this.fetchingService.get('THERAPY_TOPIC_TRANSLATIONS', { params: { language: this.vm.user.deviceLanguage || 'en_GB' } })
			.then((response) => {
				this.vm.availableTherapies = response;
			});
	}
	
	getCoachingTopics() {
		this.fetchingService.get('COACHING_TOPICS', { params: { language: this.vm.user.deviceLanguage || 'en_GB' } })
			.then((response) => {
				this.vm.coachingTopics = response;
			});
	}
	
	handleStatusUpdates(statuses) {
		this.angularHelperService.forEach(this.vm.appointments, (appointment) => {
			try {
				var id: any = appointment.service.user.id;
				if (!id) return;
				if (statuses[id]) appointment.service.user.status = statuses[id].status;
			} catch (e) {}
		});
	}
	
	toggleDrawer(e) {
		if (e && e.preventDefault) e.preventDefault();
		this.angularBroadcastHelperService.rootBroadcast("openMainDrawer", {});
	}
	
	initializeSearch() {
		this.vm.searchLanguages = this.config.getServiceLanguages();
		
		this.vm.doctorLocations = [
			{ 'label': 'DE', 'value': 'DE' },
			{ 'label': 'EE', 'value': 'EE' },
			{ 'label': 'FI', 'value': 'FI' },
			{ 'label': 'GB', 'value': 'GB' },
			{ 'label': 'LT', 'value': 'LT' },
			{ 'label': 'LV', 'value': 'LV' },
			{ 'label': 'RU', 'value': 'RU' },
			{ 'label': 'SE', 'value': 'SE' }
		];
		this.vm.availableTags = [];
		this.vm.availableTherapies = [];
		
		this.vm.search = this.urlUtil.getSearchParams();
		if (!!this.vm.search.conditions && !Array.isArray(this.vm.search.conditions)) {
			this.vm.search.conditions = [this.vm.search.conditions];
		}
		if (!!this.vm.search.therapies && !Array.isArray(this.vm.search.therapies)) {
			this.vm.search.therapies = [this.vm.search.therapies];
		}
	}
	
	triggerSearch(isStatic) {
		var search: any = this.angularHelperService.copy(this.vm.search || {});
		if (search.lang) search.lang = search.lang.join(',');
		Object.keys(search).forEach((key) => {
			return (!search[key] || !search[key].length) && delete search[key];
		});
		if (!isStatic) this.angularRoutingHelperService.setQueryParams(search);
	}
	
	getLanguagesText() {
		if (!this.vm.search.lang || !this.vm.search.lang.length) 
			return this.angularFilterHelperService.translate('Services.Filter.Languages');
		return Array.from(this.vm.search.lang, (lang) => {
			return this.angularFilterHelperService.translate('Services.Language.' + lang);
		}).join(', ');
	}
	
	getLocationText() {
		if (!this.vm.search.location || !this.vm.search.location) 
			return this.angularFilterHelperService.translate('Services.Filter.Location');
		return this.angularFilterHelperService.translate('Services.Location.' + this.vm.search.location);
	}
	
	getConditionsText() {
		if (!this.vm.search.conditions || !this.vm.search.conditions.length) 
			return this.angularFilterHelperService.translate('Services.Filter.Condition');
		var conditions: any = Array.isArray(this.vm.search.conditions)
			? Array.from(this.vm.search.conditions, (condition) => {
				return condition;
			}) : [this.vm.search.conditions];
		var translatedItems: Array<any> = [];
		for (var i = 0; i < conditions.length; i++) {
			for (var j = 0; j < this.vm.availableTags.length; j++) {
				if (conditions[i] === this.vm.availableTags[j].tag.name) {
					translatedItems.push(this.vm.availableTags[j].translation);
				}
			}
		}
		return translatedItems.join(', ');
	}
	
	getTherapiesText() {
		if (!this.vm.search.therapies || !this.vm.search.therapies.length) 
			return this.angularFilterHelperService.translate('Services.Filter.Therapies');
		var therapies: any = Array.isArray(this.vm.search.therapies)
			? Array.from(this.vm.search.therapies, (therapy) => {
				return therapy;
			}) : [this.vm.search.therapies];
		var translatedItems: Array<any> = [];
		for (var i = 0; i < therapies.length; i++) {
			for (var j = 0; j < this.vm.availableTherapies.length; j++) {
				if (therapies[i] === this.vm.availableTherapies[j].therapy.name) {
					translatedItems.push(this.vm.availableTherapies[j].translation);
				}
			}
		}
		return translatedItems.join(', ');
	}

	private updatePanelWidth(target: 'conditionPanelWidth' | 'therapyPanelWidth', select: MatSelect | undefined) {
		if (!select) {
			this[target] = null;
			this.vm[target] = this[target];
			return;
		}
		this.angularHelperService.createTimer(() => {
			this[target] = this.calculateDoublePanelWidth(select);
			this.vm[target] = this[target];
		});
	}

	private calculateDoublePanelWidth(select: MatSelect): number | null {
		const triggerElement = select?.trigger?.nativeElement;
		if (!triggerElement) {
			return null;
		}
		const triggerWidth = triggerElement.getBoundingClientRect().width;
		if (window.innerWidth <= 768) {
			return triggerWidth;
		}
		return triggerWidth * 2;
	}
	
}
